"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wallet = void 0;
var provider_1 = require("../provider");
var ledger_1 = require("./ledger");
var key_1 = require("./key");
var crypto_1 = require("@cosmjs/crypto");
var utility_1 = require("./utility");
var bip39_1 = require("@cosmjs/crypto/build/bip39");
var proto_1 = require("../proto");
var types_1 = require("./types");
var signdoc_1 = require("@cosmjs/amino/build/signdoc");
/**
 * Wallet is a single account abstraction
 * that can interact with the blockchain
 */
var Wallet = /** @class */ (function () {
    function Wallet() {
        var _this = this;
        /**
         * Connects the wallet to the specified {@link Provider}
         * @param {Provider} provider the active {@link Provider}, if any
         */
        this.connect = function (provider) {
            _this.provider = provider;
        };
        // Account manipulation //
        /**
         * Fetches the address associated with the wallet
         */
        this.getAddress = function () {
            return _this.signer.getAddress();
        };
        /**
         * Fetches the account sequence for the wallet
         * @param {number} [height=latest] the block height
         */
        this.getAccountSequence = function (height) { return __awaiter(_this, void 0, void 0, function () {
            var address;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.provider) {
                            throw new Error('provider not connected');
                        }
                        return [4 /*yield*/, this.getAddress()];
                    case 1:
                        address = _b.sent();
                        return [2 /*return*/, this.provider.getAccountSequence(address, height)];
                }
            });
        }); };
        /**
         * Fetches the account number for the wallet. Errors out if the
         * account is not initialized
         * @param {number} [height=latest] the block height
         */
        this.getAccountNumber = function (height) { return __awaiter(_this, void 0, void 0, function () {
            var address;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.provider) {
                            throw new Error('provider not connected');
                        }
                        return [4 /*yield*/, this.getAddress()];
                    case 1:
                        address = _b.sent();
                        return [2 /*return*/, this.provider.getAccountNumber(address, height)];
                }
            });
        }); };
        /**
         * Fetches the account balance for the specific denomination
         * @param {string} [denomination=ugnot] the fund denomination
         */
        this.getBalance = function (denomination) { return __awaiter(_this, void 0, void 0, function () {
            var address;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.provider) {
                            throw new Error('provider not connected');
                        }
                        return [4 /*yield*/, this.getAddress()];
                    case 1:
                        address = _b.sent();
                        return [2 /*return*/, this.provider.getBalance(address, denomination ? denomination : 'ugnot')];
                }
            });
        }); };
        /**
         * Fetches the current (recommended) average gas price
         */
        this.getGasPrice = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (!this.provider) {
                    throw new Error('provider not connected');
                }
                return [2 /*return*/, this.provider.getGasPrice()];
            });
        }); };
        /**
         * Estimates the gas limit for the transaction
         * @param {Tx} tx the transaction that needs estimating
         */
        this.estimateGas = function (tx) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (!this.provider) {
                    throw new Error('provider not connected');
                }
                return [2 /*return*/, this.provider.estimateGas(tx)];
            });
        }); };
        /**
         * Returns the connected provider, if any
         */
        this.getProvider = function () {
            return _this.provider;
        };
        /**
         * Generates a transaction signature, and appends it to the transaction
         * @param {Tx} tx the transaction to be signed
         * @param {(messages: Any[]) => any[]} decodeTxMessages tx message decode callback
         * that should expand the concrete message fields into an object. Required because
         * the transaction sign bytes are generated using sorted JSON, which requires
         * encoded message values to be decoded for sorting
         */
        this.signTransaction = function (tx, decodeTxMessages) { return __awaiter(_this, void 0, void 0, function () {
            var status, chainID, address, accountNumber, accountSequence, publicKey, defaultSigTimestamp, signPayload, signBytes, wrappedKey, txSignature;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.provider) {
                            throw new Error('provider not connected');
                        }
                        // Make sure the tx fee is initialized
                        if (!tx.fee) {
                            throw new Error('invalid transaction fee provided');
                        }
                        return [4 /*yield*/, this.provider.getStatus()];
                    case 1:
                        status = _c.sent();
                        chainID = status.node_info.network;
                        return [4 /*yield*/, this.getAddress()];
                    case 2:
                        address = _c.sent();
                        return [4 /*yield*/, this.provider.getAccountNumber(address)];
                    case 3:
                        accountNumber = _c.sent();
                        return [4 /*yield*/, this.provider.getAccountSequence(address)];
                    case 4:
                        accountSequence = _c.sent();
                        return [4 /*yield*/, this.signer.getPublicKey()];
                    case 5:
                        publicKey = _c.sent();
                        defaultSigTimestamp = '0001-01-01T00:00:00Z';
                        signPayload = {
                            chain_id: chainID,
                            account_number: accountNumber.toString(10),
                            sequence: accountSequence.toString(10),
                            fee: {
                                gas_fee: tx.fee.gasFee,
                                gas_wanted: tx.fee.gasWanted.toString(10),
                            },
                            msgs: decodeTxMessages(tx.messages),
                            memo: tx.memo,
                            time: defaultSigTimestamp,
                        };
                        signBytes = (0, utility_1.stringToUTF8)((0, signdoc_1.sortedJsonStringify)(signPayload));
                        wrappedKey = {
                            key: publicKey,
                        };
                        _b = {
                            pubKey: {
                                typeUrl: types_1.Secp256k1PubKeyType,
                                value: proto_1.PubKeySecp256k1.encode(wrappedKey).finish(),
                            }
                        };
                        return [4 /*yield*/, this.getSigner().signData(signBytes)];
                    case 6:
                        txSignature = (_b.signature = _c.sent(),
                            _b);
                        // Append the signature
                        return [2 /*return*/, __assign(__assign({}, tx), { signatures: __spreadArray(__spreadArray([], tx.signatures, true), [txSignature], false) })];
                }
            });
        }); };
        /**
         * Returns the associated signer
         */
        this.getSigner = function () {
            return _this.signer;
        };
    }
    /**
     * Encodes and sends the transaction. If the type of endpoint
     * is a broadcast commit, waits for the transaction to be committed to the chain.
     * The transaction needs to be signed beforehand.
     * Returns the transaction hash (base-64)
     * @param {Tx} tx the signed transaction
     * @param {BroadcastType} endpoint the transaction broadcast type (sync / commit)
     */
    Wallet.prototype.sendTransaction = function (tx, endpoint) {
        return __awaiter(this, void 0, void 0, function () {
            var encodedTx;
            return __generator(this, function (_b) {
                if (!this.provider) {
                    throw new Error('provider not connected');
                }
                encodedTx = (0, provider_1.uint8ArrayToBase64)(proto_1.Tx.encode(tx).finish());
                // Send the encoded transaction
                return [2 /*return*/, this.provider.sendTransaction(encodedTx, endpoint)];
            });
        });
    };
    var _a;
    _a = Wallet;
    // Wallet initialization //
    /**
     * Generates a private key-based wallet, using a random seed
     * @param {AccountWalletOption} options the account options
     */
    Wallet.createRandom = function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var _b, publicKey, privateKey, wallet;
        return __generator(_a, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, utility_1.generateKeyPair)((0, bip39_1.entropyToMnemonic)((0, utility_1.generateEntropy)()), 0)];
                case 1:
                    _b = _c.sent(), publicKey = _b.publicKey, privateKey = _b.privateKey;
                    wallet = new _a();
                    wallet.signer = new key_1.KeySigner(privateKey, crypto_1.Secp256k1.compressPubkey(publicKey), options === null || options === void 0 ? void 0 : options.addressPrefix);
                    return [2 /*return*/, wallet];
            }
        });
    }); };
    /**
     * Generates a bip39 mnemonic-based wallet
     * @param {string} mnemonic the bip39 mnemonic
     * @param {CreateWalletOptions} options the wallet generation options
     */
    Wallet.fromMnemonic = function (mnemonic, options) { return __awaiter(void 0, void 0, void 0, function () {
        var _b, publicKey, privateKey, wallet;
        return __generator(_a, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, utility_1.generateKeyPair)(mnemonic, options === null || options === void 0 ? void 0 : options.accountIndex)];
                case 1:
                    _b = _c.sent(), publicKey = _b.publicKey, privateKey = _b.privateKey;
                    wallet = new _a();
                    wallet.signer = new key_1.KeySigner(privateKey, crypto_1.Secp256k1.compressPubkey(publicKey), options === null || options === void 0 ? void 0 : options.addressPrefix);
                    return [2 /*return*/, wallet];
            }
        });
    }); };
    /**
     * Generates a private key-based wallet
     * @param {string} privateKey the private key
     * @param {AccountWalletOption} options the account options
     */
    Wallet.fromPrivateKey = function (privateKey, options) { return __awaiter(void 0, void 0, void 0, function () {
        var publicKey, wallet;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, crypto_1.Secp256k1.makeKeypair(privateKey)];
                case 1:
                    publicKey = (_b.sent()).pubkey;
                    wallet = new _a();
                    wallet.signer = new key_1.KeySigner(privateKey, crypto_1.Secp256k1.compressPubkey(publicKey), options === null || options === void 0 ? void 0 : options.addressPrefix);
                    return [2 /*return*/, wallet];
            }
        });
    }); };
    /**
     * Creates a Ledger-based wallet
     * @param {LedgerConnector} connector the Ledger device connector
     * @param {CreateWalletOptions} options the wallet generation options
     */
    Wallet.fromLedger = function (connector, options) {
        var _b;
        var wallet = new _a();
        wallet.signer = new ledger_1.LedgerSigner(connector, (_b = options === null || options === void 0 ? void 0 : options.accountIndex) !== null && _b !== void 0 ? _b : 0, options === null || options === void 0 ? void 0 : options.addressPrefix);
        return wallet;
    };
    return Wallet;
}());
exports.Wallet = Wallet;
